import { type PagePopupAppState, type PopupAppState } from "@client/types/AppState/popups";
import { createSelector } from "reselect";
import { idPropsSelector } from "./props";
import { pagePopupsSelector, popupsSelector } from "./state";

export const makePopupSelector = () =>
  createSelector(
    [popupsSelector, idPropsSelector],
    (items, id): PopupAppState | null => (items ? items.find((x) => x.id === id) : null) ?? null
  );

export const makePagePopupSelector = () =>
  createSelector([pagePopupsSelector, idPropsSelector], (items, id): PagePopupAppState | undefined =>
    items.find((x) => x.id === id)
  );
